import { __require as requireFileSaver_min } from '../node_modules/.pnpm/file-saver@2.0.5/node_modules/file-saver/dist/FileSaver.min.js';

var FileSaver_minExports = requireFileSaver_min();

export { FileSaver_minExports as F };
//# sourceMappingURL=FileSaver.min.js.map
